module.exports = __webpack_public_path__ + "static/media/fal_fal_loa_bay.4b92f0da.png";